<template>
  <div class="ice-option" ref="root">
    <div
      @click.stop="ShowOption"
      class="select-text"
      :class="{ 'can-not-click': CanClick == false }"
      ref="text"
    >
      <div class="show-text">
        {{ SelectText }}
      </div>
      <div
        class="select-text-after"
        :class="{ 'img-rolate': IfShowOption }"
      ></div>
    </div>

    <div class="ice-option-down" ref="options" v-portal>
      <transition :name="fade" ref="tra">
        <div v-if="IfShowOption" class="ice-option-ul" ref="option">
          <scrollbar :config="config">
            <div class="select-ul">
              <div
                v-for="(item, index) in SelectArr"
                :key="index"
                class="select-li"
                @click="ChangeSelect(index)"
                ref="lis"
              >
                {{ item.text }}
                <div
                  class="select-text-after-li"
                  v-if="item.child"
                  @mouseenter="setseclist(index)"
                ></div>
                <div
                  ref="sec"
                  v-show="showsec && item.child && SelectShow[index]"
                  class="selec-sec"
                >
                  <div class="selec-ul-sec">
                    <div
                      class="select-li-sec"
                      v-for="(itemsec, indexsec) in item.child"
                      :key="indexsec"
                      @click="ChangeSelectsec(index, indexsec)"
                    >
                      <!-- <div></div> -->
                      {{ itemsec.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </scrollbar>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "select",
    event: "change",
  },
  props: {
    select: [String, Number, Object], //允许绑定的类型
    SelectArr: {
      //下拉的数组
      type: Array,
      default: () => [],
    },
    Placeholder: {
      //绑定数据第一次传的空显示的文字
      type: String,
      default: "",
    },
    CanClick: {
      //是否可以点击
      type: Boolean,
      default: true,
    },
    transition: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      IfShowOption: false, //列表是否显示
      SelectText: "", //上面单选框显示的内容
      SelectAll: [], //下面列表的内容（如果带value和text就把text都复制在里面）
      config: {
        size: 5,
        disableX: true,
        occupy: true,
        scrollHeight: 180,
      },
      TopOrDown: 0,

      fade: "fade",
      showsec: false,
      SelectShow: [],
    };
  },

  directives: {
    portal: {
      inserted: function (el, binding) {
        var value = binding.value;
        var app = document.querySelector("#app");
        try {
          if (value) {
            typeof value == "string"
              ? document.querySelector(value).appendChild(el)
              : value.appendChild(el);
          } else app.appendChild(el);
        } catch (error) {
          console.log(error);
        }
      },
      unbind: function (el) {
        try {
          el.parentNode.removeChild(el);
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
  methods: {
    setseclist(index) {
      this.SelectShow.forEach((it, id) => {
        this.$set(this.SelectShow, id, false);
      });
      this.$set(this.SelectShow, index, true);
      this.showsec = true;

      this.$nextTick(() => {
        var secsty = this.$refs.sec[index].getBoundingClientRect();
        var sec = this.$refs.sec[index];
        var lis = this.$refs.lis[index].getBoundingClientRect();
        var clwidth = document.documentElement.clientWidth;
        var clheight = document.documentElement.clientHeight;
        var text = this.$refs.text.getBoundingClientRect();

        if (
          text.left + text.width + secsty.width > clwidth &&
          lis.top + secsty.height > clheight
        ) {
          sec.style.top = lis.top - secsty.height + lis.height + "px";

          sec.style.left = text.left - secsty.width + "px";
        } else if (
          text.left + text.width + secsty.width < clwidth &&
          lis.top + secsty.height > clheight
        ) {
          sec.style.top = lis.top - secsty.height + lis.height + "px";
          sec.style.left = text.left + text.width + "px";
        } else if (
          text.left + text.width + secsty.width > clwidth &&
          lis.top + secsty.height < clheight
        ) {
          sec.style.top = lis.top + "px";

          sec.style.left = text.left - secsty.width + "px";
        } else {
          sec.style.top = lis.top + "px";
          sec.style.left = text.left + text.width + "px";
        }
      });
    },
    ShowOption() {
      //点击框
      //   if (this.IfShowOption == false) return;
      if (this.CanClick == false) return;
      this.IfShowOption = !this.IfShowOption;
      this.TopOrDown =
        document.documentElement.clientHeight -
        this.$refs.root.getBoundingClientRect().top -
        this.$refs.root.getBoundingClientRect().height;
      this.computePosition();
    },
    ChangeSelect(index) {
      //点击点击下拉列表
      (this.IfShowOption = false), (this.showsec = false);
      this.$emit("change", this.SelectArr[index]);
    },
    ChangeSelectsec(index, indexsec) {
      //点击点击下拉列表
      this.showsec = false;
      this.IfShowOption = false;
      this.$emit("change", this.SelectArr[index].child[indexsec]);
    },
    window_click(e) {
      if (this.$refs.root && this.$refs.root.contains(e.target)) return;
      var id = this.SelectShow.indexOf(true);
      (this.$refs.option && this.$refs.option.contains(e.target)) ||
        (this.$refs.sec &&
          id &&
          this.$refs.sec[id] &&
          this.$refs.sec[id].contains(e.target)) ||
        ((this.IfShowOption = false), (this.showsec = false));
    },
    mousewheel(e) {
      (this.$refs.option && this.$refs.option.contains(e.target)) ||
        ((this.IfShowOption = false), (this.showsec = false));
      this.computePosition();
    },
    keydown(e) {
      (this.IfShowOption = false), (this.showsec = false);
    },
    computePosition() {
      this.$nextTick(function () {
        var text = this.$refs.text.getBoundingClientRect();
        var app = document.getElementById("app").getBoundingClientRect();
        var options = this.$refs.options.getBoundingClientRect();
        let root = this.$refs.root.getBoundingClientRect();
        var ops = this.$refs.options;

        var ops = this.$refs.options;
        if (this.fade == "fade") {
          ops.style.top = root.top + text.height - 1 + "px";
        } else {
          {
            ops.style.top =
              root.top - options.height + 1 - this.config.size + "px";
          }
        }

        ops.style.left = text.left + "px";
        ops.style.width = root.width + "px";

        // document.getElementById("app").appendChild(this.$refs.options);
      });
    },
    animate_complete() {
      let root = this.$refs.root;
      root && (root.style["z-index"] = 0);
    },
    item_mousewheel(e) {
      e.stopPropagation();
    },
  },
  // created() {
  //   this.SelectArr.forEach;
  // },
  mounted() {
    window.addEventListener("mousedown", this.window_click, true);
    window.addEventListener("keydown", this.keydown);
    document.addEventListener("scroll", this.mousewheel, true);
    window.addEventListener("resize", this.computePosition);

    this.TopOrDown =
      document.documentElement.clientHeight -
      this.$refs.root.getBoundingClientRect().top -
      this.$refs.root.getBoundingClientRect().height;
  },
  beforeDestroy() {
    window.removeEventListener("mousedown", this.window_click, true);
    window.removeEventListener("keydown", this.keydown);
    document.removeEventListener("scroll", this.mousewheel, true);
    window.removeEventListener("resize", this.computePosition);
  },
  watch: {
    //监听绑定数据和下拉数组，防止异步操作
    select: {
      handler: function (newdata) {
        if (typeof newdata == "object") {
          if (newdata && !!newdata.value && !!newdata.text) {
            this.SelectText = this.select.text;
          } else {
            this.SelectText = this.Placeholder;
          }
        } else {
          if (!!newdata) {
            this.SelectText = this.select;
          } else {
            this.SelectText = this.Placeholder;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    SelectArr: {
      handler: function (newdata) {
        newdata.forEach((it, id) => {
          this.SelectShow[id] = false;
        });
      },
      deep: true,
      immediate: true,
    },
    IfShowOption: {
      handler: function (value) {
        let target = this.$refs.root;
        if (value) {
          target.style["z-index"] = 9999;
          this.$nextTick((_) => {
            this.$refs.option.addEventListener(
              "mousewheel",
              this.item_mousewheel
            );
          });
        } else {
          target.style["z-index"] = 9999;
        }
      },
    },
    TopOrDown: {
      handler: function (value) {
        if (value > 160) {
          this.fade = "fade";
        } else {
          this.fade = "fade2";
        }
      },
    },
    deep: true,
    immediate: true,
  },
};
</script>

<style scoped>
.ice-option {
  position: relative;
  display: inline-block;

  vertical-align: middle;
  line-height: 28px;
  user-select: none;
  cursor: pointer;
}
.ice-option-ul {
  display: block;
  /* position: absolute;
  top: 31px; */
  background: white;
  border: 1px solid #cccccc;
  /* overflow: hidden; */
  transform: translateY(0);
  width: 100%;
  box-sizing: border-box;
}
.ice-option-down {
  position: fixed;
  top: 31px;
  overflow: hidden;
  width: 100%;
  z-index: 9999;
  box-sizing: border-box;
}
.select-text-after {
  /* float: right; */
  position: absolute;
  right: 8px;
  top: 7px;
  width: 12px;
  height: 17px;
  margin-right: 8px;
  -webkit-transition: all 0.3s, -webkit-transform 0.3s; /* For Safari 3.1 to 6.0 */
  transition: all 0.3s, transform 0.3s;
  mask: url(../../../assets/images/TV_01.png) no-repeat center;
  background: #a6a8c5;
}
.select-text-after-li {
  /* float: right; */
  position: absolute;
  right: 8px;
  top: 2px;
  width: 12px;
  height: 27px;
  margin-right: 8px;
  /* -webkit-transition: all 0.3s, -webkit-transform 0.3s; 
  transition: all 0.3s, transform 0.3s; */
  mask: url(../../../assets/images/TV_01.png) no-repeat center;
  background: #a6a8c5;
  -webkit-transform: rotate(270deg); /* Chrome, Safari, Opera */
  transform: rotate(270deg);
}
.select-text {
  display: inline-block;
  width: 100%;
  min-height: 38px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  white-space: nowrap;
  border-radius: 4px;
}
.show-text {
  padding-left: 12px;
  float: left;
  width: calc(100% - 25px);
  margin-right: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select-li {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  min-height: 30px;
  line-height: 30px;
  padding-left: 5px;
}
.select-ul :hover {
  font-size: 18px;
  color: white;
  background: #619df5;
  cursor: pointer;
}
.select-ul {
  /* display: inline-block; */

  width: 100%;
  max-height: 180px;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
  transform: translateY(-100%);
}
.fade-enter-to,
.fade-leave {
  transform: translateY(0);
}
.fade2-enter-active,
.fade2-leave-active {
  transition: all 0.3s;
}
.fade2-enter,
.fade2-leave-to {
  transform: translateY(100%);
}
.fade2-enter-to,
.fade2-leave {
  transform: translateY(0);
}
.img-rolate {
  -webkit-transform: rotate(180deg); /* Chrome, Safari, Opera */
  transform: rotate(180deg);
}

.can-not-click {
  color: #a6a8c5;
  border: 1px solid #a6a8c5;
  cursor: not-allowed;
}
.selec-ul-sec {
  width: 100%;
}
.selec-sec {
  box-sizing: border-box;
  position: absolute;
  left: 100px;
  top: 100px;
  background: white;
  border: 1px solid #cccccc;
  z-index: 9999;
  overflow: hidden;
  display: block;
  width: 200px;
}

.select-li-sec {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  min-height: 30px;
  line-height: 30px;
  padding-left: 5px;
}
.selec-ul-sec :hover {
  font-size: 18px;
  color: white;
  background: #619df5;
}
/* .select-text-after-li:hover + .selec-ul-sec {
  visibility: visible;
} */
</style>